import React from 'react';
import Card from '../card/Card';

class Accordion extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      content: []
    }
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.data !== undefined) {
      return {
        content: nextProps.data
      }
    } else {
      return {
        content: []
      }
    }
  }

  render() {
    return (
      <div id='accordion' className='accordion'>
        {
          this.state.content.map((config, i) => {
            return (
              <Card
                key={'c' + '-' + config.project_id + '-' + i}
                id={config.form_id}
                content={config}
                size={this.props.size}
                show={this.props.show}
              />
            )
          })
        }
      </div>
    );
  }
}

export default Accordion